/*
 * TeacherPulseCheck "student placement" rules, shared by the wizard's answered-check and the
 * multitext renderer so the gate and the progress bar can never disagree.
 *
 * When the survey is opened with a valid numberOfStudents url param, every multitext question
 * with numeric options must have its numeric inputs total exactly that number.
 */

const DIGITS_ONLY = /^\d+$/

// integer > 0 from the raw url param, otherwise undefined (feature off)
export const parseNumberOfStudents = (raw) => {
  const str = String(raw ?? '').trim()
  if (!DIGITS_ONLY.test(str)) {
    return undefined
  }
  const num = Number(str)
  return num > 0 ? num : undefined
}

// Sums the numeric-option inputs for one question. Empty inputs count as 0; any non-empty
// value that isn't a non-negative integer marks the placement invalid.
export const getStudentPlacement = (questionObj = {}, answerObj = {}) => {
  const { answerOptions = [] } = questionObj
  const { answerArray = [] } = answerObj

  const numericOptionIds = answerOptions.filter(({ number }) => number).map(({ id }) => id)
  const hasNumericOptions = numericOptionIds.length > 0

  let placed = 0
  let isEveryValueValid = true

  answerArray.forEach(({ id, answerText }) => {
    if (!numericOptionIds.includes(id)) {
      return
    }
    const str = String(answerText ?? '').trim()
    if (str === '') {
      return
    }
    if (!DIGITS_ONLY.test(str)) {
      isEveryValueValid = false
      return
    }
    placed += Number(str)
  })

  return { hasNumericOptions, placed, isEveryValueValid }
}

// true/false when the rule applies to this question, undefined when it doesn't (no numeric
// options) so the caller falls back to the normal multitext rule
export const isStudentPlacementComplete = (questionObj, answerObj, total) => {
  const { hasNumericOptions, placed, isEveryValueValid } = getStudentPlacement(questionObj, answerObj)
  if (!hasNumericOptions) {
    return undefined
  }
  return isEveryValueValid && placed === total
}
